import { createConfig, http, injected } from 'wagmi'
import { CHAIN, RPC_URL } from './faucet.config'

/**
 * Base mainnet only.
 *
 * Listing exactly one chain means `useSwitchChain` can only ever target Base,
 * and any other connected network is unambiguously "wrong network" in the UI.
 *
 * Wallet discovery is EIP-6963 (`multiInjectedProviderDiscovery`), so every
 * injected wallet the browser exposes — MetaMask, Coinbase Wallet extension,
 * Rabby, Brave and so on — shows up by name with no wallet hard-coded, no API
 * key and no WalletConnect project id. The plain `injected()` connector is the
 * fallback for browsers that predate EIP-6963.
 *
 * The explicit `target: 'metaMask'` entry guarantees MetaMask is offered BY
 * NAME even where an EIP-6963 announcement is missed. It is deliberately NOT
 * the `metaMask()` SDK connector, which would pull in @metamask/sdk for a label.
 *
 * `reconnectOnMount` is disabled in main.tsx and useWallet reconnects only
 * against the app's own flag — see src/lib/connection.ts for why.
 *
 * Connector ORDER is load-bearing: ConnectDialog keeps the first entry for a
 * given provider, so MetaMask must stay ahead of the generic connector.
 */
export const wagmiConfig = createConfig({
  chains: [CHAIN],
  connectors: [injected({ target: 'metaMask' }), injected({ shimDisconnect: true })],
  multiInjectedProviderDiscovery: true,
  transports: {
    [CHAIN.id]: http(RPC_URL),
  },
})

declare module 'wagmi' {
  interface Register {
    config: typeof wagmiConfig
  }
}
